import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

function createGradient(color1, color2) {
  return `linear-gradient(to bottom, ${color1}, ${color2})`;
}

// SETUP COLORS — Bilalsadasub brand (matches the Flutter app)
// Primary = gold (kGold #F8C736); Secondary = near-black (kOnGold #131313)
const PRIMARY = {
  lighter: '#FEF7DE',
  light: '#FBDC72',
  main: '#F8C736',
  dark: '#CB9A1E',
  darker: '#8A6910',
  contrastText: '#131313',
};
const SECONDARY = {
  lighter: '#D6D6D9',
  light: '#4A4A4E',
  main: '#131313',
  dark: '#0A0A0A',
  darker: '#000000',
  contrastText: '#FFFFFF',
};
const INFO = {
  lighter: '#D0F2FF',
  light: '#74CAFF',
  main: '#1890FF',
  dark: '#0C53B7',
  darker: '#04297A',
};
const SUCCESS = {
  lighter: '#E9FCD4',
  light: '#AAF27F',
  main: '#54D62C',
  dark: '#229A16',
  darker: '#08660D',
};
const WARNING = {
  lighter: '#FFF7CD',
  light: '#FFE16A',
  main: '#FFC107',
  dark: '#B78103',
  darker: '#7A4F01',
};
const ERROR = {
  lighter: '#FFE7D9',
  light: '#FFA48D',
  main: '#FF4842',
  dark: '#B72136',
  darker: '#7A0C2E',
};

const GREY = {
  0: '#FFFFFF',
  100: '#FAFAF7',
  200: '#F4F4F1',
  300: '#E8E8E3',
  400: '#C9C9C4',
  500: '#9A9A96',
  600: '#6B6B67',
  700: '#3F3F3C',
  800: '#1F1F1E',
  900: '#131313',
  500_8: alpha('#9A9A96', 0.08),
  500_12: alpha('#9A9A96', 0.12),
  500_16: alpha('#9A9A96', 0.16),
  500_24: alpha('#9A9A96', 0.24),
  500_32: alpha('#9A9A96', 0.32),
  500_48: alpha('#9A9A96', 0.48),
  500_56: alpha('#9A9A96', 0.56),
  500_80: alpha('#9A9A96', 0.8),
};

const GRADIENTS = {
  primary: `linear-gradient(135deg, ${PRIMARY.darker} 0%, ${PRIMARY.main} 55%, ${PRIMARY.light} 100%)`,
  info: createGradient(INFO.light, INFO.main),
  success: createGradient(SUCCESS.light, SUCCESS.main),
  warning: createGradient(WARNING.light, WARNING.main),
  error: createGradient(ERROR.light, ERROR.main),
};

const CHART_COLORS = {
  violet: ['#826AF9', '#9E86FF', '#D0AEFF', '#F7D2FF'],
  blue: ['#CB9A1E', '#F8C736', '#FBDC72', '#FEF7DE'],
  green: ['#2CD9C5', '#60F1C8', '#A4F7CC', '#C0F2DC'],
  yellow: ['#FFE700', '#FFEF5A', '#FFF7AE', '#FFF3D6'],
  red: ['#FF6C40', '#FF8F6D', '#FFBD98', '#FFF2D4'],
};

const COMMON = {
  common: { black: '#000', white: '#fff' },
  primary: { ...PRIMARY, contrastText: '#131313' },
  secondary: { ...SECONDARY, contrastText: '#fff' },
  info: { ...INFO, contrastText: '#fff' },
  success: { ...SUCCESS, contrastText: GREY[800] },
  warning: { ...WARNING, contrastText: GREY[800] },
  error: { ...ERROR, contrastText: '#fff' },
  grey: GREY,
  gradients: GRADIENTS,
  chart: CHART_COLORS,
  divider: GREY[500_24],
  action: {
    hover: GREY[500_8],
    selected: GREY[500_16],
    disabled: GREY[500_80],
    disabledBackground: GREY[500_24],
    focus: GREY[500_24],
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

const palette = {
  light: {
    ...COMMON,
    mode: 'light',
    text: { primary: GREY[900], secondary: GREY[600], disabled: GREY[500] },
    background: { paper: '#fff', default: GREY[100], neutral: GREY[200] },
    action: { active: GREY[600], ...COMMON.action },
  },
  dark: {
    ...COMMON,
    mode: 'dark',
    text: { primary: '#fff', secondary: GREY[400], disabled: GREY[600] },
    background: { paper: GREY[800], default: GREY[900], neutral: GREY[500_16] },
    action: { active: GREY[400], ...COMMON.action },
  },
};

export default palette;
